export const EAGLES_REF = ['UofF', 'Shands', 'HardinCounty']

export const MODA_REDEMPTION_URL_MATCH = {
  TRUTHBRUSH: 'moda.truthbrush.com',
  Z_DENTAL: 'myzsonic.com/moda',
  MYLABS: 'mldstaging.wpengine.com',
  IREDEEM: 'order.iredeemhealth.com'
}

export const MODA_REDEMPTION_URL_MATCH_ORDER = [
  MODA_REDEMPTION_URL_MATCH.TRUTHBRUSH,
  MODA_REDEMPTION_URL_MATCH.Z_DENTAL,
  MODA_REDEMPTION_URL_MATCH.MYLABS,
  MODA_REDEMPTION_URL_MATCH.IREDEEM
]
